//#region src/__generated__/internal/payment/types/PaymentView.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const paymentViewInvoiceStatusEnum = {
	NOT_ISSUED: "NOT_ISSUED",
	ISSUED: "ISSUED",
	SENT: "SENT"
};
const paymentViewPaymentFlagEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
//#endregion
//#region src/__generated__/internal/payment/types/SetPaymentFlagBody.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setPaymentFlagBodyFlagEnum = {
	UNDER_REVIEW: "UNDER_REVIEW",
	NO_PAYMENT: "NO_PAYMENT",
	PAID: "PAID"
};
//#endregion
export { paymentViewInvoiceStatusEnum as n, paymentViewPaymentFlagEnum as r, setPaymentFlagBodyFlagEnum as t };

//# sourceMappingURL=SetPaymentFlagBody.js.map